import { render } from "./Suggest.vue?vue&type=template&id=51dc23e4&scoped=true"
import script from "./Suggest.vue?vue&type=script&lang=js"
export * from "./Suggest.vue?vue&type=script&lang=js"

import "./Suggest.vue?vue&type=style&index=0&id=51dc23e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dc23e4"]])

export default __exports__